import script from "./AdminView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminView.vue?vue&type=style&index=0&id=7a6b7ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6b7ada"]])

export default __exports__